import isEqual from 'lodash.isequal';

import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { BasketService } from '@core/services/basket/basket.service';
import { regexValidator } from '@shared/form-elements/custom-validators/regex.validator';
import { RegexService } from '@shared/regex/regex.service';

import { CustomValidatorFn, ValidationErrorKeys } from '../model/form-elements.model';
import { basketCouponValidator } from './basket-coupon.validator';
import { basketGiftCardValidator } from './basket-gift-card.validator';
import { NotificationService } from '@core/services/notification/notification.service';
import { membershipValidator } from '@shared/form-elements/custom-validators/membership-validator';
import { ClubService } from '@features/club/service/club.service';
import { storesValidator } from '@shared/form-elements/custom-validators/stores.validator';
import { StoresService } from '@features/stores-overview/service/stores.service';

@Injectable({
    providedIn: 'root'
})
export class CustomValidatorsService {
    public readonly companyNameMaxLength = 50;
    public readonly emailMaxLength = 254;
    // used 24 because we need to join the first and the last name, so we need to use a space between them to make a total of 50 chars for the full name
    public readonly firstNameMaxLength = 24;
    public readonly lastNameMaxLength = 25;
    public readonly fullNameMaxLength = 50;
    public readonly addressMaxLength = 50;
    public readonly zipCodeMaxLength = 4;
    public readonly cityMaxLength = 30;
    public readonly phoneNumberMaxLength = 20;
    public readonly cvrLength = 8;

    public readonly email = regexValidator(this.regexService.email, 'email');
    public readonly zipCode = regexValidator(this.regexService.zipCode, 'zipCode');
    public readonly phoneNumber = regexValidator(this.regexService.phoneNumber, 'phoneNumber');
    public readonly basketCoupon = basketCouponValidator(this.basketService, this.notificationService);
    public readonly basketGiftCard = basketGiftCardValidator(this.basketService, this.notificationService);
    public readonly isAMemberShip = membershipValidator(this.clubService);
    public readonly validateStore = storesValidator(this.storesService);
    public readonly date = regexValidator(this.regexService.date, 'date');
    public readonly cvr = regexValidator(this.regexService.cvr, 'cvr');

    constructor(
        private clubService: ClubService,
        private regexService: RegexService,
        private basketService: BasketService,
        private storesService: StoresService,
        private notificationService: NotificationService
    ) {}

    public static isEqualToField(matchTo: string, errorType: ValidationErrorKeys): CustomValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let validator: ValidationErrors | null = { [errorType]: true };
            if (control.parent?.controls) {
                const controlToMatch: AbstractControl = (control.parent as UntypedFormGroup).controls[matchTo];
                if (controlToMatch && isEqual(control.value, controlToMatch.value)) {
                    validator = null;
                }
            }
            return validator;
        };
    }
}
